// user-state.service.ts
import { Injectable, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserInfo } from '../../domain/user/user-info';
import { Environment, ENVIRONMENT } from './../auth/auth.tokens';
import { UserRole } from 'libs/domain';


@Injectable({ providedIn: 'root' })
export class UserStateService {
  // signal de l'usuari. es privat per evitar que es modifiqui des de fora del servei
  private _user = signal<UserInfo | null>(null);
  // signal d'usuari nomes de lectura
  readonly user = this._user.asReadonly();

  // per evitar multiples peticions en paralel
  private _loadInProgress: Promise<UserInfo> | null = null;

  private options: Environment = inject(ENVIRONMENT);
  private apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = `${this.options.baseUrl.auth}`;
  }
  
  setUser(user: UserInfo){
    this._user.set(user);
  }

  clearUserInfo() {
    this._user.set(null);
    this._loadInProgress = null;
  }
  
  hasAccessTo(schemaId: string){
    return this.user()?.memberships.some(m => m.schema_id === schemaId);
  }

  hasAccessToWithRole(schemaId: string, role: UserRole){
    return this.user()?.memberships.some(m => m.schema_id === schemaId && m.role === role);
  }
}